import { defineStore } from 'pinia';
import { getBoothsTags, loadSellerInfo, setCompanyInfo, setSellerPic, setShopInfo } from '@/api/seller';

interface SellerBoothState {
  image: string
  name: string
  mobile: string
  email: string
  address: string
  announcement: string
  qq: string
  weixin: string
  qqImage: string
  wxImage: string
  tag: string
  lat: string
  lng: string
  tags: number[]
}

interface SellerCompanyState {
  name: string
  code: string
  license: string
  state: number
  reason: string
  isUpLicense: 0 | 1 | 2
  isUpLicenseText: string
}

interface SellerInfoState {
  booth: SellerBoothState
  company: SellerCompanyState
  boothTags: API.BoothsTag[]
}

export const useSellerInfo = defineStore({
  id: 'seller-info',
  state: (): SellerInfoState => ({
    booth: {
      image: '',
      name: '',
      mobile: '',
      email: '',
      address: '',
      announcement: '',
      qq: '',
      weixin: '',
      qqImage: '',
      wxImage: '',
      tag: '',
      lat: '',
      lng: '',
      tags: [],
    },
    company: {
      name: '',
      code: '',
      license: '',
      state: 0,
      reason: '',
      isUpLicense: 0,
      isUpLicenseText: '',
    },
    boothTags: [] as API.BoothsTag[],
  }),
  getters: {},
  actions: {
    async getBoothInfo() {
      const res = await loadSellerInfo();
      if (res) {
        this.booth.image = res.image;
        this.booth.name = res.shop_name;
        this.booth.mobile = res.mobile;
        this.booth.email = res.email;
        this.booth.address = res.address;
        this.booth.announcement = res.announcement;
        this.booth.qq = res.qq;
        this.booth.weixin = res.weixin;
        this.booth.qqImage = res.qq_image;
        this.booth.wxImage = res.weixinimage;
        this.booth.tag = res.seller_tag;
        this.booth.lat = res.lat;
        this.booth.lng = res.lng;
        this.booth.tags = res.seller_tag_id;

        this.company.name = res.qy_name;
        this.company.code = res.qy_code;
        this.company.license = res.license_url;
        this.company.state = res.is_up_license;
        this.company.reason = res.license_error_msg;
        this.company.isUpLicenseText = res.is_up_license_text;
      }
    },
    async setBoothAvatar(img: string) {
      return setSellerPic({ img });
    },
    async setBoothInfo({ name, mobile, email, announcement, weixin, wxImage, qqImage, address, tags }: {
      name: string
      mobile: string
      email: string
      announcement: string
      weixin: string
      wxImage: string
      qqImage: string
      address: string
      tags: number[]
    }) {
      return setShopInfo({
        shop_name: name,
        announcement,
        address,
        lat: this.booth.lat,
        lng: this.booth.lng,
        email,
        weixin,
        weixinimage: wxImage,
        qq: this.booth.qq,
        qq_image: qqImage,
        seller_mobile: mobile,
        seller_tag_id: tags,
      });
    },
    async setBoothLocation({ lat, lng }: { lat: string, lng: string }) {
      return setShopInfo({
        shop_name: this.booth.name,
        announcement: this.booth.announcement,
        address: this.booth.address,
        lat,
        lng,
        email: this.booth.email,
        weixin: this.booth.weixin,
        weixinimage: this.booth.wxImage,
        qq: this.booth.qq,
        qq_image: this.booth.qqImage,
        seller_mobile: this.booth.mobile,
        seller_tag_id: this.booth.tags,
      });
    },
    async setLicenseInfo({ name, code, license }: { name: string, code: string, license: string }) {
      return setCompanyInfo({ qy_name: name, qy_code: code, license_url: license });
    },
    async getTags() {
      const data = await getBoothsTags();
      this.boothTags = data;
    },
  },
});
